function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHabitHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1432",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-536.685,-785.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Habit-Hero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ribbon-Border",
    d: "M777.976,1775.02C632.582,1678.31 536.685,1512.98 536.685,1325.43C536.685,1027.63 778.462,785.853 1076.26,785.853C1374.06,785.853 1615.84,1027.63 1615.84,1325.43C1615.84,1512.66 1520.28,1677.74 1375.31,1774.52L1501.35,2113.29C1506.26,2126.49 1497.78,2140.62 1482.42,2144.85L1340.34,2110.68L1248.69,2209.07C1233.32,2213.29 1216.88,2206.01 1211.97,2192.8L1089.95,1864.84C1085.4,1864.95 1080.84,1865.01 1076.26,1865.01C1072.03,1865.01 1067.8,1864.96 1063.59,1864.86L939.279,2199.82C934.366,2213.06 917.926,2220.36 902.559,2216.13L810.904,2117.49L668.83,2151.75C653.463,2147.51 644.989,2133.35 649.903,2120.11L777.976,1775.02Z",
    style: {
      fill: "white",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner-Circle",
    transform: "matrix(-1,0,0,1,2149.79,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1074.89,
    cy: 1325.52,
    r: 503.155,
    style: {
      fill: "url(#_Radial1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Crown",
    transform: "matrix(1.08656,0,0,1.08656,657.655,1017.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crown-Shape",
    transform: "matrix(1,0,0,1,-0.323609,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.572,231.578C78.61,229.287 68.752,217.956 68.752,204.341C68.752,189.076 81.146,176.682 96.411,176.682C111.677,176.682 124.071,189.076 124.071,204.341C124.071,210.59 121.995,216.357 118.495,220.99C137.795,262.643 171.358,272.825 186.846,265.196C214.284,251.681 219.212,218.586 215.117,163.21C203.666,159.05 195.477,148.067 195.477,135.187C195.477,118.738 208.832,105.383 225.281,105.383C241.73,105.383 255.085,118.738 255.085,135.187C255.085,143.447 251.717,150.927 246.281,156.327C263.537,227.153 284.807,243.501 302.867,243.184C323.533,242.82 353.748,205.774 361.731,117.527C361.747,117.344 406.859,117.115 406.868,117.215C414.777,205.849 445.073,243.043 465.78,243.408C483.681,243.722 504.736,227.664 521.91,158.408C515.126,152.943 510.782,144.568 510.782,135.187C510.782,118.738 524.136,105.383 540.586,105.383C557.035,105.383 570.389,118.738 570.389,135.187C570.389,146.955 563.553,157.14 553.639,161.983C549.351,218.232 554.125,251.787 581.802,265.42C597.307,273.057 630.926,262.844 650.217,221.074C646.678,216.427 644.576,210.628 644.576,204.341C644.576,189.076 656.97,176.682 672.236,176.682C687.502,176.682 699.896,189.076 699.896,204.341C699.896,217.926 690.081,229.237 677.161,231.563L628.801,366.314L140.515,367.956L91.572,231.578Z",
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.984006,0,0,0.984006,-5.45255,-9.31145)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 396.057,
    cy: 97.012,
    r: 39.505,
    style: {
      fill: "rgb(254,168,42)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Crown-Top-Highlights"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.963138,0,0,0.953231,-279.269,123.537)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(254,199,95)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(254,199,95)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.836702,0,0,0.828095,347.184,132.858)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(254,199,95)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829876,0,0,0.84248,216.822,62.8289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(254,199,95)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829876,0,0,0.84248,-98.8933,62.8289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(254,199,95)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Middle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00069,0,0,2.16497,1.17521,-368.092)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 382.559,
    cy: 350.254,
    rx: 246.034,
    ry: 13.49,
    style: {
      fill: "rgb(230,156,37)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.21034,0,-91.6088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.672,381.513C302.985,354.45 462.261,354.432 621.5,382.253L612.905,435.349L153.519,435.516L143.672,381.513Z",
    style: {
      fill: "rgb(254,187,57)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.105,428.854L328.163,428.854L302.867,243.184C302.867,243.184 321.206,243.571 337.555,211.73C347.828,191.722 355.766,166.303 361.429,117.527C361.45,117.345 406.518,117.344 406.537,117.527C411.666,166.49 420.146,191.891 430.42,211.899C446.769,243.74 465.371,243.406 465.371,243.406L440.105,428.854Z",
    style: {
      fill: "rgb(254,168,42)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00069,0,0,2.44969,1.17521,-490.976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.527,359.668L136.526,350.254C136.526,342.808 246.77,336.764 382.559,336.764C518.349,336.764 628.593,342.808 628.593,350.254L628.593,359.707C628.585,353.127 518.344,347.786 382.559,347.786C247.039,347.786 136.964,353.106 136.527,359.668Z",
    style: {
      fill: "rgb(254,199,95)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.29982,-53.9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.543,519.312L145.7,519.312L145.7,494.315C145.7,478.614 251.896,465.868 382.7,465.868C513.504,465.868 619.7,478.615 619.7,494.315C619.7,494.348 619.7,494.381 619.699,494.414L619.699,519.312L495.859,519.312C462.225,521.512 423.669,522.763 382.7,522.763C341.731,522.763 303.177,521.512 269.543,519.312Z",
    style: {
      fill: "rgb(254,199,95)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.29982,-28.9249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 382.7,
    cy: 494.315,
    rx: 237,
    ry: 28.448,
    style: {
      fill: "rgb(240,149,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997209,0,0,1.17085,-8.86379,-109.88)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.963,
    cy: 482.761,
    rx: 206.908,
    ry: 15.72,
    style: {
      fill: "rgb(207,96,24)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Jewels"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32892,0,0,1.32892,-127.302,166.497)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06999,0,0,1.06999,-31.0859,-8.16177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(45,116,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.750392,0,0,0.750392,99.9156,14.9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.198747,0,0,0.198747,321.262,52.7932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(185,231,195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.69339,0,0,0.686257,251.824,234.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06999,0,0,1.06999,-31.0859,-8.16177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(45,116,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.750392,0,0,0.750392,99.9156,14.9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.198747,0,0,0.198747,321.262,52.7932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(185,231,195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.69339,0,0,0.686257,-18.3256,234.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06999,0,0,1.06999,-31.0859,-8.16177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(45,116,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.750392,0,0,0.750392,99.9156,14.9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.198747,0,0,0.198747,321.262,52.7932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(185,231,195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.572594,0,0,0.566703,389.414,265.729)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06999,0,0,1.06999,-31.0859,-8.16177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(45,116,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.750392,0,0,0.750392,99.9156,14.9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.198747,0,0,0.198747,321.262,52.7932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(185,231,195)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.572594,0,0,0.566703,-63.1202,265.729)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20668,0,0,1.20668,-86.137,-17.6758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06999,0,0,1.06999,-31.0859,-8.16177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(45,116,60)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.750392,0,0,0.750392,99.9156,14.9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(57,176,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.198747,0,0,0.198747,321.262,52.7932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.707,
    cy: 83.602,
    r: 22.45,
    style: {
      fill: "rgb(185,231,195)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Right-Tail",
    transform: "matrix(1,0,0,1,4,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.71,1864.27C1195.52,1859.34 1283.88,1829.88 1359.58,1782.13L1477.01,2097.75C1481.46,2109.73 1473.77,2122.55 1459.83,2126.38L1330.91,2095.38L1247.74,2184.66C1233.79,2188.49 1218.87,2181.88 1214.42,2169.9L1100.71,1864.27Z",
    style: {
      fill: "url(#_Linear3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Tail",
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.07,1864.33L930.237,2176.43C925.789,2188.41 910.906,2195.02 896.994,2191.19L814.016,2101.89L685.393,2132.9C671.482,2129.07 663.81,2116.25 668.258,2104.26L787.459,1783.08C863.149,1830.48 951.413,1859.62 1046.07,1864.33Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(499.895,-3.99724,3.99724,499.895,1075.21,1330.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(198,31,5)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(156,25,1)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(631.144,0,0,262.573,68.7517,236.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(254,168,42)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "rgb(254,175,48)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(254,183,54)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(254,187,57)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(254,183,54)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(254,175,48)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(254,168,42)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(218.887,297.03,-297.03,218.887,1248.54,1842.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(254,187,57)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(208,96,24)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-342.037,282.864,-282.864,-342.037,1029.15,1864.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(254,187,57)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(206,97,24)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabitHero);
export default __webpack_public_path__ + "static/media/HabitHero.a338749acec34ba4ce15010f0761ef72.svg";
export { ForwardRef as ReactComponent };